import {init} from "cmp-web-base/modules/init";
import AnalyticManager from "cmp-web-base/modules/analytic/analytic-manager";
import {EAction, ELabel} from "cmp-web-base/modules/analytic/event-definition";
import ConsentModeManager from "cmp-web-base/modules/consent-mode/consent-mode-manager";
import {type ConsentData} from "cmp-web-base/modules/api/model/consent-data";
init();

const cmp_api:string = '__tcfapiprivate';
const cmp = (c: string, o?: string|null, cb?: Function) => {
    (window as any)[cmp_api](c,o,cb);
}

cmp('addEventListener', 'changedConfiguration', (consentData: ConsentData) => {
    // ConsentMode
    ConsentModeManager().notify(consentData.acceptanceLevel === 1);
});
cmp('addEventListener', 'cmpReady', (consentData: ConsentData) => {
    cmp('needAcquireConsent', null, (need: boolean) => {
        if (need) {
            cmp('isGDPRExcludedPrivateCommand', null, (excluded: boolean) => {
                if (!excluded) cmp('showGdpr');
            });
        }
        else {
            cmp('gdprAlreadyAccepted');
            AnalyticManager().register({
                action: EAction.GDPR,
                label: ELabel.YA_ACEPTADO
            });
            // ConsentMode
            ConsentModeManager().notify(consentData.acceptanceLevel === 1);
        }
    });
});
